/**
 * Customer-facing labels for proof & readiness (no backend contract changes).
 */

export function humanizeZoneLabel(raw?: string | null): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  if (/^seconddemo$/i.test(s)) return 'Seconddemo';
  if (/testdemopedestrian/i.test(s)) return 'Demo pedestrian zone';
  if (/hello_test/i.test(s)) return 'Hello test zone';
  if (/^test[-_]?demo/i.test(s) && /pedestrian/i.test(s)) return 'Demo pedestrian zone';
  return s
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

export function humanizeAreaLabel(raw?: string | null): string {
  const zoneLabel = humanizeZoneLabel(raw);
  if (!zoneLabel) return '';
  if (/^seconddemo$/i.test(zoneLabel)) return 'Seconddemo area';
  if (/\bzone$/i.test(zoneLabel)) return zoneLabel.replace(/\bzone$/i, 'area').trim();
  return zoneLabel;
}

/** Replace known internal zone tokens inside longer copy. */
export function humanizeProofBodyText(text: string): string {
  let t = String(text || '');
  t = t.replace(/\bseconddemo\b/gi, 'Seconddemo');
  t = t.replace(/\btestdemopedestrian\b/gi, 'Demo pedestrian zone');
  t = t.replace(/\bhello_test\b/gi, 'Hello test zone');
  return t;
}
